import { useAuth } from './useAuth';

export function useHasPlatformPermission(permissionCode: string): boolean {
  const { platformPermissions } = useAuth();
  return platformPermissions.includes(permissionCode);
}
